// ============================================
// ConverseTech Frontend - Session Timer
// ============================================

import { Clock } from 'lucide-react';
import { useSessionStore } from '../stores/sessionStore';
import { useElapsedTime } from '../hooks/useElapsedTime';

/**
 * Displays the elapsed time for the current session.
 * Automatically starts when session becomes active.
 */
export default function SessionTimer() {
  const isActive = useSessionStore((state) => state.isActive);
  const { formatted } = useElapsedTime({ isActive });

  return (
    <div data-testid="session-timer" className="flex items-center gap-2 text-gray-400">
      <Clock className="w-4 h-4" />
      <span className="font-mono">{formatted}</span>
    </div>
  );
}
